import { render, staticRenderFns } from "./settings.html?vue&type=template&id=0ce8a16c&"
import script from "./settings.js?vue&type=script&lang=js&"
export * from "./settings.js?vue&type=script&lang=js&"
import style0 from "./settings.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports